import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { LocationWrapper } from './components/LocationWrapper';

async function loadLocationStep(): Promise<typeof LocationWrapper> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-location" */ './components/LocationWrapper'))
		.LocationWrapper;
}

export const LocationLoader: React.FC = () => {
	return (
		<LazyComponent
			loadComponent={loadLocationStep}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
};

export const preloadLocationStep = loadLocationStep;
